import React, { useState, useEffect } from "react";
import {
  Note,
  DividerWrapSmall,
  Events,
  Followups,
  HeroCard,
  dictionary,
  AddNoteDialog,
  ManageCategoriesWidget,
  UploadPreview
} from "./SalientComponents.js";
import { Button } from "@material-ui/core";
import {validateBirthday, fileValidation} from './Util.js';

const DataRow = ({ contact, field, label, edit, value, callback, isMandatory, placeholder }) => {
  const required = (isMandatory != null) ? true : false;
  const placeHolder = placeholder != null ? placeholder : "";
  const editField =
    value != null ? (
      <input
        name={field}
        value={value[field]}
        placeholder={placeHolder} 
        onChange={v => callback({ ...value, [field]: v.target.value })}
        required = {required}
      />
    ) : null;
  return (contact != null && contact[field] != null && contact[field] !== "") ||
    edit ? (
    <div className="dataRow">
      <div className="dataRowLabel">
      <strong>{label}{(edit == true && required==true)?<span className="redColor"> *</span>:""}</strong>
      </div>
      <div className="dataRowField">{edit ? editField : contact[field]}</div>
    </div>
  ) : null;
};

const BirthdayRow = ({ contact, field, label, edit, value, callback }) => {

  const editFieldForMonth =
    value != null ? (
      <EditMonth field={field} value={value} callback={callback} />
    ) : null;

    const editFieldForDay =
    value != null ? (
      <EditDay field={field} value={value} callback={callback} />
    ) : null;

    const editFieldForYear =
    value != null ? (
      <EditYear field={field} value={value} callback={callback} />
    ) : null;

  return (contact != null && contact[field + "Date"] != null && contact[field + "Date"] !== "" && contact[field + "Date"] !== "00/00/0000") ||
    edit ? (
    <div className="dataRow">
      <div className="dataRowLabel">
        <strong>{label}</strong>
      </div>
      <div className="dataRowField">
        {edit ? editFieldForMonth : contact[field + "Date"].indexOf("/0000") != -1 ? contact[field + "Date"].replace("/0000","/----") : contact[field + "Date"].indexOf("/0004") != -1 ? contact[field + "Date"].replace("/0004","/----"):contact[field + "Date"]}
        {edit ? editFieldForDay : null}
        {edit ? editFieldForYear : null} {edit ? <span> year optional</span> : null}
      </div>
    </div>
  ) : null;
};

const EditMonth = ({ field, value, callback }) => {
  return (
    <select
      id="MonthDrop"
      name={field + "Month"}
      value={value[field + "Month"]}
      onChange={v => callback({ ...value, [field + "Month"]: v.target.value })}
      style={{ width: "auto" }}
    >
     <option value="00" selected >Select a Month </option>
      <option value="01" >January</option>
      <option value="02">February</option>
      <option value="03">March</option>
      <option value="04">April</option>
      <option value="05">May</option>
      <option value="06">June</option>
      <option value="07">July</option>
      <option value="08">August</option>
      <option value="09">September</option>
      <option value="10">October</option>
      <option value="11">November</option>
      <option value="12">December</option>
    </select>
  );
};

const EditDay = ({ field, value, callback }) => {
  return (
    <input
        id ="daytext"
        name={field + "Day"}
        value={value[field + "Day"] == 0 ? null : value[field+"Day"]}
        onChange={v => callback({ ...value, [field + "Day"]: v.target.value })}
        style={{ width: "32px", margin: "8px" }}
        maxlength="2"
      />
  );
};

const EditYear = ({ field, value, date, callback }) => {
  return (
    <input
        id="yeartext" 
        name={field + "Year"}
        value={value[field + "Year"] == "0000" || "0004" ? null : value[field + "Year"]}
        onChange={v => callback({ ...value, [field + "Year"]: v.target.value })}
        style={{ width: "50px" }}
        maxlength="4"
        placeholder="YYYY"
      />  
  );
};

const EmailRow = ({ contact, field, label, edit, value, callback }) => {
  const editField =
    value != null ? (
      <input
        name={field}
        value={value[field]}
        onChange={v => callback({ ...value, [field]: v.target.value })}
      />
    ) : null;
  const editType = (
    <select
      name={field + "Type"}
      value={value != null ? value[field + "Type"] : ""}
      onChange={v => callback({ ...value, [field + "Type"]: v.target.value })}
      style={{ width: "auto" }}
    >
      <option>{value != null ? value[field + "Type"] : ""}</option>
      <option value="Primary">Primary</option>
      <option value="Home">Home</option>
      <option value="Work">Work</option>
      <option value="Other">Other</option>
    </select>
  );
  return (contact != null && contact[field] != null && contact[field] !== "") ||
    edit ? (
    <div className="dataRow">
      <div className="dataRowLabel">
        <strong>{edit ? label : contact[field + "Type"]}</strong>
      </div>
      <div className="dataRowField">
        {edit ? (
          editField
        ) : (
          <a
            href={"mailto:" + contact[field]}
            target="_blank"
            rel="noopener noreferrer"
          >
            {contact[field]}
          </a>
        )}{" "}
        {edit ? editType : null}
      </div>
    </div>
  ) : null;
};

const PhoneRow = ({ contact, field, label, edit, value, callback }) => {
  const editField =
    value != null ? (
      <input
        name={field}
        value={value[field]}
        onChange={v => callback({ ...value, [field]: v.target.value })}
      />
    ) : null;
  const editType = (
    <select
      name={field + "Type"}
      value={value != null ? value[field + "Type"] : ""}
      onChange={v => callback({ ...value, [field + "Type"]: v.target.value })}
      style={{ width: "auto" }}
    >
      <option>{value != null ? value[field + "Type"] : ""}</option>
      <option value="Main">Main</option>
      <option value="Mobile">Mobile</option>
      <option value="Home">Home</option>
      <option value="Work">Work</option>
      <option value="Other">Other</option>
    </select>
  );

  return (contact != null && contact[field] != null && contact[field] !== "") ||
    edit ? (
    <div className="dataRow">
      <div className="dataRowLabel">
        <strong>{edit ? label : contact[field + "Type"]}</strong>
      </div>
      <div className="dataRowField">
        {edit ? editField : contact[field]} {edit ? editType : null}
      </div>
    </div>
  ) : null;
};

const AddressRow = ({ contact, field, label, edit, value, callback }) => {
  const editField =
    value != null ? (
      <input
        name={field}
        value={value[field]}
        onChange={v => callback({ ...value, [field]: v.target.value })}
      />
    ) : null;
  const editType = (
    <select
      name={field + "Type"}
      value={value != null ? value[field + "Type"] : ""}
      onChange={v => callback({ ...value, [field + "Type"]: v.target.value })}
      style={{ width: "auto" }}
    >
      <option>{value != null ? value[field + "Type"] : ""}</option>
      <option value="Home">Home</option>
      <option value="Work">Work</option>
      <option value="Other">Other</option>
    </select>
  );

  const Comma = ", ";
  const Street = (contact[field + "Street"] != null) ? contact[field + "Street"] + Comma : "";
  const City = (contact[field + "City"] != null) ? contact[field + "City"] + Comma : "";
  const Country = (contact[field + "Country"] != null) ? contact[field + "Country"] : "";
  const State = (contact[field + "State"] != null) ? (contact[field + "State"] + ((Country != null && Country != "") ? Comma : "")) : "";  
  const Zip = (contact[field + "Zip"] != null) ? "+" + contact[field + "Zip"] : "";
  
  return (Street != null || City != "" || Country || "" || State != "" || Zip != "") ||
    edit ? (
    <div className="dataRow">
      <div className="dataRowLabel">
        <strong>{edit ? label : contact[field + "Type"]}</strong>
      </div>
      {!edit ? (
        <div className="dataRowField">
          <a
            href={
              "https://maps.google.com/?q=" + Street + City + State + Country + Zip
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {Street + City + State + Country + Zip}
          </a>
        </div>
      ) : (
        <div className="dataRowField">
          {value != null ? (
            <div>
              <input
                name={field + "Street"}
                value={value[field + "Street"]}
                placeholder="Address"
                onChange={v => callback({ ...value, [field + "Street"]: v.target.value })}
              />
            </div>
          ) : null}
          {value != null ? (
            <div>
              <input
                name={field + "City"}
                value={value[field + "City"]}
                placeholder="City"
                onChange={v =>
                  callback({ ...value, [field + "City"]: v.target.value })
                }
              />
            </div>
          ) : null}
          {value != null ? (
            <div>
              <input
                name={field + "State"}
                value={value[field + "State"]}
                placeholder="State"
                onChange={v =>
                  callback({ ...value, [field + "State"]: v.target.value })
                }
              />
            </div>
          ) : null}
          {value != null ? (
            <div>
              <input
                name={field + "Country"}
                value={value[field + "Country"]}
                placeholder="Country"
                onChange={v =>
                  callback({ ...value, [field + "Country"]: v.target.value })
                }
              />
            </div>
          ) : null}
          {value != null ? (
            <div>
              <input
                name={field + "Zip"}
                value={value[field + "Zip"]}
                placeholder="Zip"
                onChange={v =>
                  callback({ ...value, [field + "Zip"]: v.target.value })
                }
              />
            </div>
          ) : null}
          {edit ? <div>{editType}</div> : null}
        </div>
      )}
    </div>
  ) : null;
};

const LinkRow = ({ contact, field, label, edit, value, callback }) => {
  const editField =
    value != null ? (
      <input
        name={field}
        value={value[field]}
        onChange={v => callback({ ...value, [field]: v.target.value })}
      />
    ) : null;
  return (contact != null && contact[field] != null && contact[field] !== "") ||
    edit ? (
    <div className="dataRow">
      <div className="dataRowLabel">
        <strong>{label}</strong>
      </div>
      <div className="dataRowField">
        {edit ? (
          editField
        ) : (
          <a href={(contact[field].toLowerCase().startsWith('www') ? "//" : contact[field].toLowerCase().startsWith('http') ? "" : "//") + contact[field]} target="_blank" rel="noopener noreferrer">
            Link
          </a>
        )}
      </div>
    </div>
  ) : null;
};

const ContactDetailPage = props => {
  const [contact, setContact] = useState(null);
  const [notes, setNotes] = useState([]);
  const [filteredNotes, setFilteredNotes] = useState(null);
  const [search, setSearch] = useState("");
  const [edit, setEdit] = useState(false);
  const [values, setValues] = useState(null);
  const [openNoteDialog, setOpenNoteDialog] = useState(false);

  const manageCategoriesWidget = (
    <ManageCategoriesWidget
      wordpressId={props.wordpressId}
      contacts={contact != null ? [contact] : null}
      contactsCallback={setContact}
      nonce={props.nonce}
    />
  );

  const fetchContactDetail = async id => {
    await fetch("/wp-json/prism/v1/contact-detail/" + id, {
      headers: { "X-WP-Nonce": props.nonce }
    })
      .then(response => response.json())
      .then(result => {
        setContact(result);
        setValues(result);
      });
  };

  const fetchNotes = async id => {
    await fetch("/wp-json/prism/v1/notes/" + id, {
      headers: { "X-WP-Nonce": props.nonce }
    })
      .then(response => response.json())
      .then(result => setNotes(result));
  };

  const createNote = async n => {
    await fetch("/wp-json/prism/v1/create-note/", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({
        contactId: contact.id,
        note: n,
        wordpressId: props.wordpressId
      })
    })
      .then(response => response.json())
      .then(result => {
        setNotes(result);
      });
  };

  const editNote = async (id, note) => {
    await fetch("/wp-json/prism/v1/update-note/", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({
        id: id,
        contactId: contact.id,
        note: note
      })
    })
      .then(response => response.json())
      .then(result => {
        setNotes(result);
      });
  };

  const deleteNote = async id => {
    await fetch("/wp-json/prism/v1/delete-note/", {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": props.nonce
      },
      body: JSON.stringify({
        id: id,
        contactId: contact.id
      })
    })
      .then(response => response.json())
      .then(result => {
        setNotes(result);
      });
  };

  useEffect(() => {
    fetchContactDetail(props.contactId);
    fetchNotes(props.contactId);
  }, [props.contactId, props.contactid]);

  useEffect(() => {
    if (search !== "") {
      let n = notes.slice();
      const s = search.toLowerCase();
      n = n.filter(item => item.note.toLowerCase().indexOf(s) > -1);
      setFilteredNotes(n);
    } else {
      setFilteredNotes(notes.slice());
    }
  }, [search, notes]);

  function sortNotes(a, b) {
    let r = 0;
    r = a < b ? 1 : -1;
    return r;
  }

  
function Image() {
  return (
    
           <UploadPreview />
     
  );
}

// class UploadPreview extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { file: null };
//     this.onChange = this.onChange.bind(this);
//     this.resetFile = this.resetFile.bind(this);
//   }
//   onChange(event) {
//     this.setState({
//       file: URL.createObjectURL(event.target.files[0])
//     });
//   }

//   resetFile(event) {
//     event.preventDefault();
//     this.setState({ file: null });
//   }
//   render() {
//     return (
//       <div className="dataRow">        
     
//       <div className="dataRowLabel">
//      <strong> Photo </strong>
//       </div>
//       <div className="dataRowField">
//         <input type="file" name="pictureRef" onChange={this.onChange} />
//         {this.state.file && (
//           <div>
//             <button onClick={this.resetFile}>Remove File</button>
//           </div>

//         )}
//         <br></br>
//         <img style={{ fontSize: "150px",
//                 lineHeight: "150px",
//                 height: "150px",
//                 width: "150px",borderRadius: 75, }} src={this.state.file} />
//         </div>
//         <div className="dataRowLabel">

//         </div>
//         <div className="dataRowField">
        
//         </div>
//         </div>
//     );
//   }
// }

// function validateBirthday(event)
// {
//   var Month = document.getElementById("MonthDrop").value;
//   var Day = document.getElementById("daytext").value;
//   var Year = document.getElementById("yeartext").value;
//   var currentYear = new Date().getFullYear();
//   Year = (Year =="" && Month != "00") ? currentYear : Year;
//   var days31 = ["01","03","05","07","08","10","12"].includes(Month);
//   var days30 = ["04","06","09","11"].includes(Month);
//   if(Month!="00")
//   {
//     if(Day =="")
//     {
//     alert("Please Enter Day");
//     event.preventDefault();
//     return false;
//     }
//   }
//   if(Day !=""){
//     if(Month=="00")
//   {
//     alert("Please select Month");
//     event.preventDefault();
//     return false;
//   }  
//   }
//   if(Year !=""){
//     if(Month=="00")
//   {
//     alert("Please select Month");
//     event.preventDefault();
//     return false;
//   }
//   if(Day =="")
//   {
//   alert("Please Enter Day");
//   event.preventDefault();
//   return false;
//   }
//   }
//   if(days31==true)
//   {
//     if(Day > 31 || Day <= 0){
//     alert("Please Enter Valid Day");
//     event.preventDefault();
//     return false;
//     }
//   }
//   if(days30 == true)
//   {
//     if(Day > 30 || Day <=0){
//     alert("Please Enter Valid Day");
//     event.preventDefault();
//     return false;
//     }
//   }
//   if(Month == "02")
//   {
//     if ((!(Year % 4) && Year % 100) || !(Year % 400))
//      {
//       if(Day > 29|| Day <=0)
//       {
//         alert("Please Enter Valid Day");
//         event.preventDefault();
//         return false;
//       }
//     }
//     else if(Day > 28 || Day <=0)
//     {
//       alert("Please Enter Valid Day");
//         event.preventDefault();
//         return false;
//     }
//   }
//   // if(Year > currentYear)
//   // {
//   //   alert("Please future entry not allowed");
//   //   event.preventDefault();
//   //   return false;
//   // }
//   return true;
// }

  return (
    <div
      data-column-margin="default"
      data-midnight="dark"
      data-bg-mobile-hidden=""
      className="wpb_row vc_row-fluid vc_row top-level standard_section "
      style={{ paddingTop: 0, paddingBottom: 0 }}
    >
      <div
        className="row-bg-wrap"
        data-bg-animation="none"
        data-bg-overlay="false"
      >
        <div className="inner-wrap">
          <div className="row-bg" />
        </div>
        <div className="row-bg-overlay" />
      </div>
      <div className="col span_12 dark left">
        <div
          className="vc_col-sm-12 wpb_column column_container vc_column_container col no-extra-padding"
          data-t-w-inherits="default"
          data-border-radius="none"
          data-shadow="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div className="wpb_text_column wpb_content_element ">
                <div className="wpb_wrapper">
                  <div
                    id="fws_5e7b878180865"
                    data-column-margin="default"
                    data-midnight="dark"
                    data-top-percent="4%"
                    data-bottom-percent="7%"
                    data-bg-mobile-hidden=""
                    className="wpb_row vc_row-fluid vc_row top-level full-width-section standard_section "
                    style={{
                      paddingTop: "calc(100vw * 0.04)",
                      paddingBottom: "calc(100vw * 0.07)"
                    }}
                  >
                    <div
                      className="row-bg-wrap"
                      data-bg-animation="none"
                      data-bg-overlay="false"
                    >
                      <div className="inner-wrap">
                        <div className="row-bg" />
                      </div>
                      <div className="row-bg-overlay" />
                    </div>
                    <div className="col span_12 dark left">
                      <HeroCard
                        key="heroCard"
                        contact={contact}
                        pageType="Detail"
                        manageCategoriesWidget={manageCategoriesWidget}
                      />
                      <div
                        className="vc_col-sm-8 wpb_column column_container vc_column_container col no-extra-padding"
                        data-t-w-inherits="default"
                        data-border-radius="none"
                        data-shadow="none"
                        data-border-animation=""
                        data-border-animation-delay=""
                        data-border-width="none"
                        data-border-style="solid"
                        data-border-color=""
                        data-bg-cover=""
                        data-padding-pos="all"
                        data-has-bg-color="false"
                        data-bg-color=""
                        data-bg-opacity="1"
                        data-hover-bg=""
                        data-hover-bg-opacity="1"
                        data-animation=""
                        data-delay="0"
                      >
                        <div className="vc_column-inner">
                          <div
                            className="column-bg-overlay-wrap"
                            data-bg-animation="none"
                          >
                            <div className="column-bg-overlay" />
                          </div>
                          <div className="wpb_wrapper">
                            <div
                              className="wpb_content_element"
                              data-interval="0"
                            >
                              <div
                                className="wpb_wrapper tabbed clearfix"
                                data-style="minimal_flexible"
                                data-spacing=""
                                data-icon-size="24"
                                data-full-width-line=""
                                data-color-scheme="extra-color-gradient-2"
                                data-alignment="left"
                              >
                                <ul className="wpb_tabs_nav ui-tabs-nav clearfix">
                                  <li>
                                    <a href="#tab-1585153858640-7">
                                      <span>Details</span>
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#tab-1585153858782-9">
                                      <span>Notes</span>
                                    </a>
                                  </li>
                                  <li>
                                    <a href="#tab-1585153859032-10">
                                      <span>Notifications</span>
                                    </a>
                                  </li>
                                  <li style={{ display: "none" }}>
                                    <a href="#tab-1585153860515-8">
                                      <span>Articles</span>
                                    </a>
                                  </li>
                                </ul>

                                <div
                                  id="tab-details"
                                  data-tab-icon="fa fa-address-book-o"
                                  className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                                >
                                  <div className="wpb_text_column wpb_content_element ">
                                    <div className="wpb_wrapper">
                                      <form
                                        action="/wp-admin/admin-post.php"
                                        method="post"
                                        enctype="multipart/form-data"
                                        onSubmit={(event)=>{
                                          validateBirthday(event);
                                         }}
                                         onInput={(event)=>{
                                          fileValidation(event);
                                         }}
                                      >
                                        <input
                                          type="hidden"
                                          name="action"
                                          value="request_edit_contact"
                                        />
                                        <input
                                          type="hidden"
                                          name="contactId"
                                          value={
                                            contact != null ? contact.id : null
                                          }
                                        />
                                        {edit ? (
                                          <Image></Image>    )
                                          :null}    
                                        {[
                                          {
                                            field: "firstName",
                                            label: "First Name",
                                            isMandatory: "Yes"                                    
                                          },
                                          {
                                            field: "lastName",
                                            label: "Last Name",
                                            isMandatory: "Yes"                                    
                                          },
                                          {
                                            field: "title",
                                            label: "Job Title"
                                          },
                                          { field: "company", label: "Company" },
                                          { field: "highSchool", label: "High School" },
                                          { field: "collegeOne", label: "College One" },
                                          { field: "collegeTwo", label: "College Two" }                                         
                                        ].map(d => (
                                          <DataRow
                                            key={"data" + d.field}
                                            field={d.field}
                                            label={d.label}
                                            contact={contact}
                                            edit={edit}
                                            value={values}
                                            callback={setValues}
                                            isMandatory={d.isMandatory}
                                            placeholder = {d.placeholder}
                                          />
                                        ))}

                                          {(contact != null &&
                                          contact.birthDate != null) ||
                                        edit ? (
                                          <div>
                                            {
                                              <BirthdayRow
                                                key={"birth"}
                                                contact={contact}
                                                field={"birth"}
                                                label="Birthday"
                                                edit={edit}
                                                value={values}
                                                callback={setValues}
                                              />
                                            }
                                          </div>
                                        ) : null}

                                        {(contact != null &&
                                          contact.emailOne != null) ||
                                        edit ? (
                                          <div>
                                            <hr />
                                            {dictionary.map(d => (
                                              <EmailRow
                                                key={"email" + d}
                                                contact={contact}
                                                field={"email" + d}
                                                label="Email"
                                                edit={edit}
                                                value={values}
                                                callback={setValues}
                                              />
                                            ))}
                                          </div>
                                        ) : null}
                                        {(contact != null &&
                                          contact.phoneOne != null) ||
                                        edit ? (
                                          <div>
                                            <hr />
                                            {dictionary.map(d => (
                                              <PhoneRow
                                                key={"phone" + d}
                                                contact={contact}
                                                field={"phone" + d}
                                                label="Phone"
                                                edit={edit}
                                                value={values}
                                                callback={setValues}
                                              />
                                            ))}
                                          </div>
                                        ) : null}
                                        {(contact != null) ||
                                        edit ? (
                                          <div>
                                            <hr />
                                            {dictionary.map(d => (
                                              <AddressRow
                                                key={"address" + d}
                                                contact={contact}
                                                field={"address" + d}
                                                label="Address"
                                                edit={edit}
                                                value={values}
                                                callback={setValues}
                                              />
                                            ))}
                                          </div>
                                        ) : null}
                                        {(contact != null &&
                                          (contact.facebook != null ||
                                            contact.linkedIn != null ||
                                            contact.instagram != null ||
                                            contact.twitter != null ||
                                            contact.websiteOne != null)) ||
                                        edit ? (
                                          <div>
                                            <hr />
                                            {[
                                              {
                                                field: "facebook",
                                                label: "Facebook"
                                              },
                                              {
                                                field: "linkedIn",
                                                label: "LinkedIn"
                                              },
                                              {
                                                field: "instagram",
                                                label: "Instagram"
                                              },
                                              {
                                                field: "twitter",
                                                label: "Twitter"
                                              },
                                              {
                                                field: "websiteOne",
                                                label: "Website"
                                              }
                                            ].map(l => (
                                              <LinkRow
                                                key={"link" + l.field}
                                                contact={contact}
                                                field={l.field}
                                                label={l.label}
                                                value={values}
                                                callback={setValues}
                                                edit={edit}
                                              />
                                            ))}
                                          </div>
                                        ) : null}                                
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-end"
                                          }}
                                        >
                                          <Button
                                            variant="outlined"
                                            onClick={() => setEdit(!edit)}
                                          >
                                            {!edit ? "Edit" : "Cancel"}
                                          </Button>
                                          {!edit ? null : (
                                            <Button
                                              variant="outlined"
                                              type="submit"
                                            >
                                              Submit
                                            </Button>
                                          )}
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  id="tab-notes"
                                  data-tab-icon="fa fa-pencil-square-o"
                                  className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                                >
                                  <div
                                    data-midnight=""
                                    data-column-margin="default"
                                    data-bg-mobile-hidden=""
                                    className="wpb_row vc_row-fluid vc_row inner_row  vc_row-o-content-top standard_section    "
                                    style={{ paddingTop: 0, paddingBottom: 0 }}
                                  >
                                    <div className="row-bg-wrap">
                                      <div className="row-bg   " />
                                    </div>
                                    <div className="col span_12  left">
                                      <div
                                        className="vc_col-sm-10 wpb_column column_container vc_column_container col child_column no-extra-padding"
                                        data-t-w-inherits="default"
                                        data-shadow="none"
                                        data-border-radius="none"
                                        data-border-animation=""
                                        data-border-animation-delay=""
                                        data-border-width="none"
                                        data-border-style="solid"
                                        data-border-color=""
                                        data-bg-cover=""
                                        data-padding-pos="all"
                                        data-has-bg-color="false"
                                        data-bg-color=""
                                        data-bg-opacity="1"
                                        data-hover-bg=""
                                        data-hover-bg-opacity="1"
                                        data-animation=""
                                        data-delay="0"
                                      >
                                        <div className="vc_column-inner">
                                          <div
                                            className="column-bg-overlay-wrap"
                                            data-bg-animation="none"
                                          >
                                            <div className="column-bg-overlay" />
                                          </div>
                                          <div className="wpb_text_column wpb_content_element ">
                                            <div
                                              className="wpb_wrapper"
                                              style={{
                                                display: "flex",
                                                alignItems: "center"
                                              }}
                                            >
                                              <h3>Notes</h3>
                                              <i
                                                className="icon-tiny fa fa-plus extra-color-2 clickable"
                                                onClick={() =>
                                                  setOpenNoteDialog(true)
                                                }
                                              />
                                              <AddNoteDialog
                                                open={openNoteDialog}
                                                setOpen={setOpenNoteDialog}
                                                callback={createNote}
                                              />
                                            </div>
                                          </div>
                                          <div className="wpb_wrapper">
                                            <div className="wpb_text_column wpb_content_element  vc_custom_1584920057101">
                                              <div
                                                className="wpb_wrapper"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  paddingLeft: "1%"
                                                }}
                                              >
                                                <i className="icon-tiny iconsmind-Magnifi-Glass22 extra-color-2" />
                                                <input
                                                  type="text"
                                                  onChange={e =>
                                                    setSearch(e.target.value)
                                                  }
                                                  value={search}
                                                  placeholder="Search Notes"
                                                  style={{ padding: "5px" }}
                                                  className="prism"
                                                />
                                                <i
                                                  className="icon-tiny fa fa-sort-numeric-asc extra-color-3 clickable"
                                                  onClick={() =>
                                                    setFilteredNotes(prev =>
                                                      prev
                                                        .slice()
                                                        .sort((a, b) =>
                                                          sortNotes(
                                                            a.lastUpdated,
                                                            b.lastUpdated
                                                          )
                                                        )
                                                    )
                                                  }
                                                />
                                                <i
                                                  className="icon-tiny fa fa-sort-numeric-desc extra-color-3 clickable"
                                                  onClick={() =>
                                                    setFilteredNotes(prev =>
                                                      prev
                                                        .slice()
                                                        .sort((a, b) =>
                                                          sortNotes(
                                                            b.lastUpdated,
                                                            a.lastUpdated
                                                          )
                                                        )
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    id="fws_5e7b87818612a"
                                    data-midnight=""
                                    data-column-margin="default"
                                    data-bg-mobile-hidden=""
                                    className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                                    style={{ paddingTop: 0, paddingBottom: 0 }}
                                  >
                                    <div className="row-bg-wrap">
                                      <div className="row-bg   " />
                                    </div>
                                    <div className="col span_12  left">
                                      <div
                                        className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column padding-1-percent"
                                        data-t-w-inherits="default"
                                        data-shadow="none"
                                        data-border-radius="none"
                                        data-border-animation=""
                                        data-border-animation-delay=""
                                        data-border-width="none"
                                        data-border-style="solid"
                                        data-border-color=""
                                        data-bg-cover=""
                                        data-padding-pos="all"
                                        data-has-bg-color="false"
                                        data-bg-color=""
                                        data-bg-opacity="1"
                                        data-hover-bg=""
                                        data-hover-bg-opacity="1"
                                        data-animation=""
                                        data-delay="0"
                                      >
                                        <div className="vc_column-inner">
                                          <div
                                            className="column-bg-overlay-wrap"
                                            data-bg-animation="none"
                                          >
                                            <div className="column-bg-overlay" />
                                          </div>
                                          <div className="wpb_wrapper">
                                            {filteredNotes != null
                                              ? filteredNotes.map(n => (
                                                  <div key={n.id}>
                                                    <DividerWrapSmall
                                                      style={{
                                                        backgroundColor:
                                                          "rgba(0,0,0,0.12)"
                                                      }}
                                                    />
                                                    <Note
                                                      key={"note" + n.id}
                                                      note={n}
                                                      editCallback={editNote}
                                                      deleteCallback={
                                                        deleteNote
                                                      }
                                                    />
                                                  </div>
                                                ))
                                              : null}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  id="tab-notifications"
                                  data-tab-icon="fa fa-bell-o"
                                  className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                                >
                                  <div className="wpb_text_column wpb_content_element ">
                                    <div className="wpb_wrapper">
                                      <p
                                        style={{
                                          textAlign: "center",
                                          width: "100%",
                                          display: "flex",
                                          justifyContent: "space-evenly"
                                        }}
                                      >
                                        <a
                                          className="nectar-button n-sc-button small see-through-2 has-icon"
                                          href="#events-section"
                                          data-color-override="#1e83ec"
                                          data-hover-color-override="#1e83ec"
                                          data-hover-text-color-override="#fff"
                                        >
                                          <span>View Events</span>
                                          <i className="iconsmind-Triangle-ArrowDown" />
                                        </a>
                                        <a
                                          className="nectar-button n-sc-button small see-through-2 has-icon"
                                          href="#followups-section"
                                          data-color-override="#1e83ec"
                                          data-hover-color-override="#1e83ec"
                                          data-hover-text-color-override="#fff"
                                        >
                                          <span>View Follow Ups</span>
                                          <i className="iconsmind-Triangle-ArrowDown" />
                                        </a>
                                      </p>
                                    </div>
                                  </div>
                                  <div className="wpb_text_column wpb_content_element ">
                                    <div
                                      id="events-section"
                                      className="wpb_wrapper"
                                      style={{ marginBottom: "10px" }}
                                    >
                                      <Events
                                        showHeader={true}
                                        contactId={props.contactId}
                                        wordpressId={props.wordpressId}
                                        nonce={props.nonce}
                                      />
                                    </div>
                                    <div
                                      id="followups-section"
                                      className="wpb_wrapper"
                                    >
                                      <Followups
                                        showHeader={true}
                                        contactId={props.contactId}
                                        wordpressId={props.wordpressId}
                                        nonce={props.nonce}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  id="tab-articles"
                                  data-tab-icon="fa fa-file-text-o"
                                  className="wpb_tab ui-tabs-panel wpb_ui-tabs-hide clearfix"
                                >
                                  <div
                                    id="fws_5e7b878199f63"
                                    data-midnight=""
                                    data-column-margin="default"
                                    data-bg-mobile-hidden=""
                                    className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                                    style={{ paddingTop: 0, paddingBottom: 0 }}
                                  >
                                    <div className="row-bg-wrap">
                                      <div className="row-bg   " />
                                    </div>
                                    <div className="col span_12  left">
                                      <div
                                        className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-2-percent"
                                        data-t-w-inherits="default"
                                        data-shadow="none"
                                        data-border-radius="none"
                                        data-border-animation=""
                                        data-border-animation-delay=""
                                        data-border-width="none"
                                        data-border-style="solid"
                                        data-border-color=""
                                        data-bg-cover=""
                                        data-padding-pos="all"
                                        data-has-bg-color="false"
                                        data-bg-color=""
                                        data-bg-opacity="1"
                                        data-hover-bg=""
                                        data-hover-bg-opacity="1"
                                        data-animation=""
                                        data-delay="0"
                                      >
                                        <div className="vc_column-inner">
                                          <div
                                            className="column-bg-overlay-wrap"
                                            data-bg-animation="none"
                                          >
                                            <div className="column-bg-overlay" />
                                          </div>
                                          <div className="wpb_wrapper">
                                            <div className="wpb_text_column wpb_content_element ">
                                              <div className="wpb_wrapper">
                                                <h3>Sent</h3>
                                                <ul>
                                                  <li>List of sent articles</li>
                                                  <li>List</li>
                                                  <li>List</li>
                                                  <li>List</li>
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-2-percent"
                                        data-t-w-inherits="default"
                                        data-shadow="none"
                                        data-border-radius="none"
                                        data-border-animation=""
                                        data-border-animation-delay=""
                                        data-border-width="none"
                                        data-border-style="solid"
                                        data-border-color=""
                                        data-bg-cover=""
                                        data-padding-pos="all"
                                        data-has-bg-color="false"
                                        data-bg-color=""
                                        data-bg-opacity="1"
                                        data-hover-bg=""
                                        data-hover-bg-opacity="1"
                                        data-animation=""
                                        data-delay="0"
                                      >
                                        <div className="vc_column-inner">
                                          <div
                                            className="column-bg-overlay-wrap"
                                            data-bg-animation="none"
                                          >
                                            <div className="column-bg-overlay" />
                                          </div>
                                          <div className="wpb_wrapper">
                                            <div className="wpb_text_column wpb_content_element ">
                                              <div className="wpb_wrapper">
                                                <h3>Unsent Articles</h3>
                                                <ul>
                                                  <li>
                                                    saved articles that have the
                                                    same category tags as this
                                                    contact
                                                  </li>
                                                  <li>
                                                    can send an article from
                                                    here
                                                  </li>
                                                  <li>
                                                    can delete the suggestion of
                                                    sending to this contact
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetailPage;